<template>
  <div class="live-quiz-result-page" :class="{'is-burmese': isBurmese}">
    <header class="result-header">
      <button type="button" class="result-back" :aria-label="$t('LiveQuizBackToSchedule')" @click="back">
        <img src="static/images/livequiz/back.png" alt="">
      </button>
    </header>

    <main class="result-main" v-if="loaded">
      <section class="result-pass-summary">
        <div class="result-pass-row">
          <img src="static/images/livequiz/over/malt_L.png" alt="">
          <div class="result-avatar-stack" aria-hidden="true"><img v-for="(avatar, index) in passAvatars" :key="index" :src="avatar" alt=""></div>
          <strong>{{ result.pass_count || 0 }} {{ $t('LiveQuizPeople') }}</strong>
          <img src="static/images/livequiz/over/malt_R.png" alt="">
        </div>
        <p>{{ $t('LiveQuizClearedLevel') }}</p>
      </section>

      <section class="result-summary">
        <h1>{{ $t('LiveQuizRoundOver') }}</h1>
        <p>{{ $t('LiveQuizAveragePassReward') }}</p>
        <div><strong>{{ result.average_pass_reward || result.average_pass_points || 0 }}</strong><em>{{ resultRewardUnit }}</em></div>
      </section>

      <section class="result-next-card" v-if="result.next_round && result.next_round.id">
        <div class="result-next-heading">
          <img src="static/images/livequiz/malt_r.png" alt="">
          <h2>{{ $t('LiveQuizNextMatch', {time: formatRoundClock(result.next_round.start_at)}) }}</h2>
          <img src="static/images/livequiz/malt_l.png" alt="">
        </div>
        <div class="result-next-prize">
          <p>{{ $t('LiveQuizMaxRewardHint', {count: result.next_round.question_count || 0}) }}</p>
          <div><strong>{{ roundRewardTotal(result.next_round) }}</strong><em>{{ roundRewardUnit(result.next_round) }}</em></div>
        </div>
        <button disabled>{{ $t('LiveQuizStartingSoon') }}</button>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data () {
    return { loaded: false, result: {round: {}} }
  },
  computed: {
    resultRewardUnit () {
      return this.result.reward_type === 'loyalty' ? this.$t('LiveQuizLoyalty') : this.$t('LiveQuizPts')
    },
    passAvatars () {
      const avatars = Array.isArray(this.result.pass_avatars) ? this.result.pass_avatars.filter(Boolean).slice(0, 4) : []
      return avatars.length ? avatars : ['static/images/default-avatar.png', 'static/images/wait-avatar.png', 'static/images/rob-avatar.png']
    },
    isBurmese () {
      return this.$i18n.locale === 'bur'
    }
  },
  created () {
    this.loadResult()
  },
  methods: {
    loadResult () {
      const roundId = this.$route.query.round_id
      if (!roundId) {
        this.back()
        return
      }
      this.$api.get('/api/live_quiz/roundresult', {round_id: roundId}, r => {
        this.$parent.returnCode(r, () => {
          this.result = r.data || {round: {}}
          this.loaded = true
        })
      })
    },
    formatRoundClock (time) {
      if (!time) return ''
      return (String(time).split(' ')[1] || '').slice(0, 5)
    },
    roundRewardTotal (round) {
      return round.reward_total === undefined || round.reward_total === null ? (round.max_points || 0) : round.reward_total
    },
    roundRewardUnit (round) {
      return round.reward_type === 'loyalty' ? this.$t('LiveQuizLoyalty') : this.$t('LiveQuizPts')
    },
    back () {
      const tab = ['history', 'today', 'tomorrow'].indexOf(this.$route.query.tab) !== -1 ? this.$route.query.tab : 'today'
      this.$router.push({path: '/liveQuizList', query: {tab: tab}})
    }
  }
}
</script>

<style scoped>
.live-quiz-result-page { position:relative; display:flex; min-height:100vh; overflow:hidden; box-sizing:border-box; flex-direction:column; padding:46px 28px 30px; color:#fff; background:#090126 url('../../static/images/livequiz/ready/bg.jpg') center top/cover no-repeat; }
.result-header { position:relative; z-index:1; width:100%; max-width:650px; margin:0 auto; }
.result-back { position:relative; z-index:1; display:block; width:72px; height:72px; padding:0; border:0; background:transparent; }.result-back img { display:block; width:100%; height:100%; object-fit:contain; }
.result-main { display:flex; width:100%; max-width:670px; flex:1; flex-direction:column; margin:0 auto; text-align:center; }
.result-pass-summary { display:flex; align-items:center; justify-content:center; flex-direction:column; margin:13vh auto 0; color:#ffd237; font-size:clamp(20px,6vw,44px); line-height:1.1; }
.result-pass-row { display:flex; align-items:center; justify-content:center; gap:9px; }.result-pass-row > img { width:clamp(28px,7vw,57px); height:clamp(48px,12vw,96px); object-fit:contain; }.result-pass-row strong { font-weight:500; }.result-pass-summary > p { margin:12px 0 0; font-size:clamp(19px,5vw,36px); line-height:1.1; }
.result-avatar-stack { display:flex; padding-left:18px; }.result-avatar-stack img { width:clamp(42px,10vw,72px); height:clamp(42px,10vw,72px); margin-left:-18px; border:2px solid #fff; border-radius:50%; object-fit:cover; background:#fff; }
.result-summary { margin:7vh auto 0; }.result-summary h1 { margin:0; color:#fff; font-size:clamp(48px,13vw,96px); font-style:italic; font-weight:900; letter-spacing:-2px; line-height:.95; text-transform:uppercase; }.result-summary p { margin:21px 0 9px; color:#fff; font-size:clamp(19px,5vw,36px); font-style:italic; line-height:1.2; }.result-summary > div,.result-next-prize > div { display:flex; align-items:flex-end; justify-content:center; gap:8px; }.result-summary strong { color:#ffd14e; font-family:Arial,sans-serif; font-size:clamp(52px,14vw,105px); font-style:italic; font-weight:900; letter-spacing:-4px; line-height:.9; text-shadow:0 6px 16px rgba(255,76,172,.3); }.result-summary em,.result-next-prize em { padding-bottom:8px; color:#ffe06e; font-size:clamp(20px,5vw,36px); font-style:normal; font-weight:800; }
.is-burmese .result-summary h1 { font-size:clamp(32px,8.6vw,58px); font-style:normal; letter-spacing:0; line-height:1.2; text-transform:none; white-space:nowrap; }.is-burmese .result-summary p { margin-top:15px; font-size:clamp(16px,4.2vw,28px); font-style:normal; }
.result-next-card { width:100%; max-width:670px; min-height:430px; margin:5vh auto 0; padding:28px 30px 20px; box-sizing:border-box; background:transparent url('../../static/images/livequiz/match_bg.png') center/100% 100% no-repeat; filter:drop-shadow(0 16px 20px rgba(0,0,0,.36)); }.result-next-heading { display:flex; min-height:70px; align-items:center; justify-content:center; gap:10px; color:#fff; }.result-next-heading img { width:36px; max-height:62px; object-fit:contain; }.result-next-heading h2 { margin:0; color:#fff; font-size:clamp(20px,5.7vw,42px); line-height:1.15; }.result-next-prize { min-height:160px; padding:6% 4% 4%; box-sizing:border-box; background:transparent url('../../static/images/livequiz/match_pts_bg.png') center/100% 100% no-repeat; }.result-next-prize p { margin:0 0 2%; color:#fff; font-size:clamp(15px,4.1vw,29px); line-height:1.2; }.result-next-prize strong { display:block; color:#fff36d; background:linear-gradient(180deg,#fffde6 0%,#fff56d 27%,#ffd24a 52%,#ff8a67 76%,#fa42d6 100%) no-repeat; background-size:100% 100%; -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; -webkit-text-stroke:1px rgba(255,247,183,.3); font-family:Arial,sans-serif; font-size:clamp(55px,16vw,120px); font-style:normal; font-weight:900; letter-spacing:-5px; line-height:.9; text-shadow:0 7px 12px rgba(255,54,168,.38); transform:skewX(-12deg); transform-origin:center bottom; }.result-next-card > button { display:block; width:70%; min-height:0; aspect-ratio:754 / 167; margin:25px auto 0; border:0; border-radius:0; color:#fff; background:transparent url('../../static/images/livequiz/btn_bg.png') center/100% 100% no-repeat; font-size:clamp(20px,5.5vw,38px); font-weight:800; }.result-next-card > button:disabled { opacity:1; }
@media (max-height:760px) { .result-pass-summary { margin-top:8vh; }.result-summary { margin-top:4vh; }.result-next-card { margin-top:3vh; } }
</style>



// WEBPACK FOOTER //
// src/page/liveQuizResult.vue